import React from 'react';
import {Box} from '@mui/material';
import PropTypes from 'prop-types';

const CalendarWrapper = ({children}) => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        position: 'relative',
        '& .PrivatePickersToolbar-root': {
          display: 'none',
        },
        '& > div': {
          minWidth: 100,
          height: '100%',
          '& > div': {
            height: '100%',
            '& > div, & .MuiCalendarPicker-root': {
              height: '100%',
              maxHeight: 360,
              width: '100%',
            },
          },
        },
        '& .PrivatePickersFadeTransitionGroup-root': {
          height: '100%',
          '& > div': {
            height: '100%',
            '& > div': {
              justifyContent: 'space-around',

              '& > .MuiTypography-root' : {
                fontSize: 14
              }
            },
          },
        },
        '& .PrivatePickersSlideTransition-root': {
          height: 'calc(100% - 40px)',
          '& > div': {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            '& > div': {
              justifyContent: 'space-around',
            },
          },
        },
        '& .MuiButtonBase-root': {
          padding: '5px',
          color: 'text.primary',
          fontSize: 14
        },
      }}
    >
      {children}
    </Box>
  );
};

export default CalendarWrapper;

CalendarWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
